<template>
  <HealthModal
    v-model:visible="visibleModal"
    autofocus
    width="20rem"
    :header="t('confirmation')"
    icon="solar:logout-2-outline"
    button-right-label="no"
    button-left-label="yes"
    :loading="loading"
    :mobile-full-screen="false"
    @confirm-action="logout()"
  >
    <HealthBaseFrame align="items-center">
      <span
        class="w-11 h-11 flex items-center justify-center rounded-xl bg-blue-100 dark:bg-blue-900"
      >
        <Icon
          icon="icon-park-outline:info"
          class="min-h-[1.6rem] min-w-[1.6rem] text-blue-500 dark:text-blue-100"
        />
      </span>

      <p class="text-xs md:text-sm dark:text-gray-300 text-center font-medium">
        {{ t("logout_confirmation") }}
      </p>
    </HealthBaseFrame>
  </HealthModal>
</template>

<script setup lang="ts">
  import { useI18n } from "vue-i18n";
  import { useRouter } from "vue-router";
  import { logoutController } from "@/app/security/controllers/logoutController";
  import { storeToRefs } from "pinia";
  import { useAuth } from "@/shared/stores/auth";
  import { Icon } from "@iconify/vue";
  import { useInstitution } from "@/shared/stores/institution";
  import { useStudyFilter } from "@/shared/stores/studyFilter";
  import HealthModal from "@/shared/components/utils/modal/HealthModal.vue";
  import HealthBaseFrame from "@/shared/components/utils/base_frame/HealthBaseFrame.vue";

  const router = useRouter();
  const { t } = useI18n();
  const visibleModal = defineModel({ type: Boolean });
  const authStore = useAuth();
  const institutionStore = useInstitution();
  const storeStudyFilter = useStudyFilter();

  const { refreshToken } = storeToRefs(authStore);

  const { request: logoutRequest, loading } = logoutController();

  async function logout() {
    await logoutRequest(refreshToken.value).then(async () => {
      await router.push("/auth/login");
      clearStores();
      visibleModal.value = false;
    });
  }

  function clearStores() {
    authStore.clearAuth();
    institutionStore.clearInstitution();
    storeStudyFilter.clearStudyFilter();
  }
</script>
